import isEmail from 'validator/es/lib/isEmail';

export const useValidation = () => {
    const directus = useDirectus();

    const validateEmail = (email: string) => {
        if (email !== '' && isEmail(email)) { return true; }
        return false;
    }

    const validateAccessCode = async (code: string) => {
        return await directus(`/submit/access-code`, {
            method: 'POST',
            body: JSON.stringify({ code })
        })
    }

    return {
        validateEmail,
        validateAccessCode
    }
}